// Enables click-and-drag swiping on the desktop product image gallery.
// The main slider runs slick in fade:true mode, which disables slick's
// built-in drag — so we attach a thin pointer listener that translates
// horizontal drags into slickPrev / slickNext.
(function () {
  const DRAG_THRESHOLD = 50; // px — must drag this far horizontally to count
  const MAX_VERTICAL = 60;   // px — bail out if drag is mostly vertical

  function bind(slider) {
    if (slider.dataset.dragBound === '1') return;
    slider.dataset.dragBound = '1';

    let startX = 0;
    let startY = 0;
    let pointerDownId = null;
    let dragged = false;
    const media = slider.querySelector(':scope');

    slider.addEventListener('pointerdown', (e) => {
      if (e.pointerType !== 'mouse') return; // touch is already handled by slick
      // Ignore drags that start on interactive children (buttons, links).
      if (e.target.closest('button, a, [role="button"]')) return;
      // Skip when zoom is active (.media has fancybox / zoom attributes)
      startX = e.clientX;
      startY = e.clientY;
      pointerDownId = e.pointerId;
      dragged = false;
      slider.style.cursor = 'grabbing';
    });

    slider.addEventListener('pointermove', (e) => {
      if (pointerDownId !== e.pointerId) return;
      const dx = e.clientX - startX;
      const dy = Math.abs(e.clientY - startY);
      if (Math.abs(dx) > 6) dragged = true;
      if (dragged) e.preventDefault();
    });

    const release = (e) => {
      if (pointerDownId !== e.pointerId) return;
      const dx = e.clientX - startX;
      const dy = Math.abs(e.clientY - startY);
      slider.style.cursor = '';
      pointerDownId = null;
      if (!dragged) return;
      if (dy > MAX_VERTICAL) return;
      if (Math.abs(dx) < DRAG_THRESHOLD) return;
      const $slider = window.jQuery ? window.jQuery(slider) : null;
      if (!$slider || !$slider.hasClass('slick-initialized')) return;
      // RTL flip
      const rtl = (window.rtl_slick === true) || document.documentElement.getAttribute('dir') === 'rtl';
      const goNext = rtl ? (dx > 0) : (dx < 0);
      $slider.slick(goNext ? 'slickNext' : 'slickPrev');
    };
    slider.addEventListener('pointerup', release);
    slider.addEventListener('pointercancel', release);

    // Suppress click that follows a drag (e.g. fancybox open).
    slider.addEventListener('click', (e) => {
      if (dragged) {
        e.stopPropagation();
        e.preventDefault();
        dragged = false;
      }
    }, true);

    slider.style.cursor = 'grab';
  }

  function bindAll() {
    document.querySelectorAll('.productView-nav').forEach(bind);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bindAll);
  } else {
    bindAll();
  }
  // Re-bind after slick init (the slider may be created later by theme.js).
  if (window.jQuery) {
    window.jQuery(document).on('init.dragNav reInit.dragNav', '.productView-nav', function () { bind(this); });
    // Late fallback in case the events fire before this script binds.
    setTimeout(bindAll, 1500);
    setTimeout(bindAll, 3500);
  }
})();
